import { MantineProvider as MantineProviderBase, type MantineProviderProps } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

import { cssVariableResolver, themeOverride } from './theme';

export function MantineProvider({ children, ...props }: MantineProviderProps) {
  return (
    <MantineProviderBase
      cssVariablesResolver={cssVariableResolver}
      defaultColorScheme="light"
      theme={themeOverride}
      {...props}>
      <Notifications />
      {children}
    </MantineProviderBase>
  );
}
